import { Dispatch, SetStateAction, Suspense } from "react";
import BannerHeader from "./BannerHeader";
import BlockLoading from "../BlockLoading";
import { Await, useLoaderData } from "react-router-dom";
import BlockLists from "../BlockLists";

export default function BannerLayout({ setTargetId, setChatOpen, headerTarget }: {
    setTargetId: Dispatch<SetStateAction<string>>
    setChatOpen: Dispatch<SetStateAction<boolean>>
    headerTarget: React.MutableRefObject<HTMLDivElement | null>
}) {
    const { design_data: designData, item_list: blockData } = useLoaderData() as any
    return (
        <div style={{ width: '100%' }}>
            <div ref={headerTarget} />
            <BannerHeader />
            <section className="blockSection">
                <Suspense fallback={<BlockLoading />}>
                    <Await resolve={blockData} errorElement={<>블록을 불러오지 못했습니다.</>}>
                        <BlockLists setTargetId={setTargetId} setChatOpen={setChatOpen} />
                    </Await>
                </Suspense>
            </section>
        </div>
    )
}